import { render } from "./Dropdown.vue?vue&type=template&id=1bcaf913&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"

import "./Dropdown.vue?vue&type=style&index=0&id=1bcaf913&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1bcaf913"

export default script